import { render, staticRenderFns } from "./DynPropBooleanDetail.vue?vue&type=template&id=5a642028"
import script from "./DynPropBooleanDetail.vue?vue&type=script&lang=js"
export * from "./DynPropBooleanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports